import React, { useState } from 'react';
import { Modal, Select, Spin, Button } from 'antd';
import { useGetCountries } from '../../hooks/genericHooks';
import { getAnchoredModalStyle } from './modalPositioning';

// Accept unified dynamic modal props
interface CountrySelectProps {
  open: boolean;
  value?: any;
  onOk: (value: any) => void;
  onCancel: () => void;
  afterClose?: () => void;
  anchorRect?: DOMRect | null;
  options?: any[];
}

const CountrySelect: React.FC<CountrySelectProps> = ({ open, value, onOk, onCancel, afterClose, anchorRect }) => {
  const { data: countriesData, isLoading } = useGetCountries();
  const [selectedId, setSelectedId] = useState<string | number | null>(value ?? null);

  const modalWidth = 520;

  // Keep internal state in sync with prop
  React.useEffect(() => {
    setSelectedId(value ?? null);
  }, [value]);

  const countriesList = Array.isArray(countriesData)
    ? countriesData
    : (countriesData?.data || []);

  return (
    <Modal
      open={open}
      title="Select Country"
      closable={true}
      getContainer={false}
      centered={!anchorRect}
      style={anchorRect ? getAnchoredModalStyle(anchorRect, { width: modalWidth }) : undefined}
      afterClose={afterClose}
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancel</Button>,
        <Button
          key="ok"
          type="primary"
          onClick={() => {
            const selectedCountry = countriesList.find((country: any) => country.id === selectedId);
            if (selectedCountry) {
              onOk(`${selectedCountry.name} (${selectedCountry.country_code})`);
            }
          }}
          disabled={!selectedId}
        >
          Select
        </Button>
      ]}
      destroyOnClose
      onCancel={onCancel}
    >
      <Spin spinning={isLoading}>
        <Select
          showSearch
          style={{ width: '100%', borderRadius: 0, background: '#e6f2ff', border: 'none' }}
          placeholder="Select a country"
          value={selectedId ?? undefined}
          onChange={setSelectedId}
          optionFilterProp="children"
          dropdownStyle={{ borderRadius: 0 }}
          filterOption={(input, option) =>
            String(option?.children).toLowerCase().includes(input.toLowerCase())
          }
        >
          {countriesList.map((country: any) => (
            <Select.Option
              key={country.id}
              value={country.id}
              title={`${country.name} (${country.country_code})`}
            >
              {country.name} ({country.country_code})
            </Select.Option>
          ))}
        </Select>
      </Spin>
    </Modal>
  );
};

export default CountrySelect;
